// extracted by mini-css-extract-plugin
export default {"AcknowledgeDeleteUserContainer":"AcknowledgeUserDelete_AcknowledgeDeleteUserContainer__feegH"};